<template>
  <component
    :is="forms[formComponent?.component]"
    :form-component="formComponent"
  />
</template>

<script setup>
import MembershipMonthlyOrDonation from './MembershipMonthlyOrDonation.vue'
import MembershipMonthly from './MembershipMonthly.vue'
import DonationStandard from './DonationStandard.vue'
import DonationSwishNumber from './DonationSwishNumber.vue'
import DonationSwishQR from './DonationSwishQR.vue'
import DonationCounter from './DonationCounter.vue'
import PetitionBlock from './PetitionForm.vue'

const forms = {
  component_id_1: MembershipMonthlyOrDonation, // TODO: Remove, legacy
  membership_monthly: MembershipMonthly,
  membership_monthly_or_donation: MembershipMonthlyOrDonation, // TODO: Remove, legacy
  membership_or_donation: MembershipMonthlyOrDonation,
  donation_counter: DonationCounter,
  donation: DonationStandard,
  swish_number: DonationSwishNumber,
  swish_qr: DonationSwishQR,
  petition: PetitionBlock,
}

defineProps({
  formComponent: Object,
})
</script>
